import Cross from './Cross';
import { ArrowUpRight, ArrowRight, MapPin, Clock, Heart } from 'lucide-react';
import heroCommunity from '../Assets/G1.jpg';

export default function Hero() {
  return (
    <section id="home" className="welcome-section">
      <div className="welcome-layout page-width">
        <div className="welcome-copy">
          <p className="eyebrow"><span /> Ethiopian Protestant Church · Paris</p>
          <h1>A place to belong.<br />A faith to <em>share.</em></h1>
          <p className="welcome-description">Rooted in Christ. Connected by community. Welcome to Rehoboth, your spiritual home in the heart of Paris.</p>
          <div className="welcome-actions">
            <a className="primary-button" href="#events">Join us this Sunday <ArrowUpRight size={18} /></a>
            <a className="text-link" href="#about">Get to know us <ArrowRight size={17} /></a>
          </div>
          <div className="welcome-note"><span className="heart-seal"><Heart size={19} /></span><span>Come as you are.<br /><strong>There’s a place for you here.</strong></span></div>
        </div>
        <div className="welcome-photo-wrap">
          <div className="welcome-photo-frame">
            <img className="welcome-photo" src={heroCommunity} alt="Members of the Rehoboth community sharing a meal together" fetchPriority="high" />
            <div className="hero-room-light" aria-hidden="true" />
            <div className="photo-caption"><Cross className="small-cross" /><div>More than a church.<br /><em>A family in faith.</em></div><span className="photo-caption-location">PARIS, FRANCE</span></div>
          </div>
          <span className="photo-side-note">FAITH · FELLOWSHIP · COMMUNITY</span>
        </div>
      </div>
      <div className="service-strip page-width">
        <div className="service-intro"><span className="status-dot" /><strong>Let’s worship together</strong><span>Every Sunday, you’re invited.</span></div>
        <div><Clock size={20} /><span><small>SUNDAY SERVICE</small><strong>14:00 – 17:00</strong></span></div>
        <a href="https://www.google.com/maps/search/?api=1&query=185+rue+des+Pyr%C3%A9n%C3%A9es+75020+Paris" target="_blank" rel="noreferrer"><MapPin size={20} /><span><small>FIND US IN PARIS</small><strong>185 rue des Pyrénées, 75020</strong></span><ArrowUpRight size={17} /></a>
      </div>
    </section>
  );
}
